import { type IWidgetDirectiveType } from '@framework/engine/schema/directives/IWidgetDirectiveType.ts';
import { isInputWidget } from '@framework/engine/schema/widgets/repository/inputs/isInputWidget.ts';
import { CustomPropertiesDirectiveConfigComponent } from './CustomPropertiesDirectiveConfigComponent.tsx';
import {
  CustomPropertiesDirectiveSchema,
  type ICustomPropertiesDirective,
} from './ICustomPropertiesDirective.ts';
import { WidgetCustomPropertiesLogic } from './WidgetCustomPropertiesLogic.ts';

/**
 * Direttiva per associare a un widget delle coppie chiave/valore personalizzate
 *
 * La UI di configurazione è mostrata solo sui widget di input, nelle sezioni
 * dati (BO/FO) e con il feature flag attivo; la direttiva è però sempre
 * registrata, così i dati già presenti restano validi anche con flag disattivo.
 */
export const CustomPropertiesDirectiveType: IWidgetDirectiveType<ICustomPropertiesDirective> =
  {
    name: 'customProperties',
    key: 'customProperties',
    allowsWidget: widget =>
      WidgetCustomPropertiesLogic.isEnabled() && isInputWidget(widget),
    // Sezioni dati BO e FO (come metadata/tableSave/…): non nelle sezioni
    // documento o senza tipo.
    supportedSectionTypes: ['BACKOFFICE', 'FRONTOFFICE'],
    configComponent: CustomPropertiesDirectiveConfigComponent,
    configSchema: CustomPropertiesDirectiveSchema,
  };
